export default __webpack_public_path__ + "static/media/CONFIANZA.1c32a8e0.jpg";